export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "ja",
    "resource": {
      "Create Bin": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["回収ボックスコードを作成する"])},
      "note": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["NOTE"])},
      "note text": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["You won’t be able to change the name after you created it."])}
    }
  })
}
